var styles = {"root":"Today_root__2ANUX","show":"Today_show__20no2","chevron":"Today_chevron__2OLSG","chevronUp":"Today_chevronUp__3_9I4","chevronDown":"Today_chevronDown__1LdAB"};

export default styles;
